import 'bootstrap';
import 'swiper/css/swiper.min.css';
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import './js/index.js';
import './scss/index.scss';